const shadows = {
	card: '0 3px 10px 0 rgba(35,36,38,0.20)'
};

export default shadows;
